module.exports = __webpack_public_path__ + "img/logo-logoplus.bf29beff.png";